var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ComparisonReferences, ElementsValuesType, SchemaElementTypes, UIElementType } from "../../interfaces/store/actions/payload/schema/schemaElements";
export var isLiteral = function (fieldElement) {
    var isLiteral = false;
    if (fieldElement.schemaType === SchemaElementTypes.STRING_TYPE
        || fieldElement.schemaType === SchemaElementTypes.INTEGER_TYPE
        || fieldElement.schemaType === SchemaElementTypes.FLOAT_TYPE
        || fieldElement.schemaType === SchemaElementTypes.BOOLEAN_TYPE
        || fieldElement.schemaType === SchemaElementTypes.TIMEPOINT_TYPE
        || fieldElement.schemaType === SchemaElementTypes.GEOMETRY_TYPE) {
        isLiteral = typeof fieldElement.literalValue !== "undefined";
    }
    return isLiteral;
};
export var isRepeatable = function (fieldElement) {
    var repeatable = false;
    if (fieldElement.schemaType === SchemaElementTypes.STRING_TYPE
        || fieldElement.schemaType === SchemaElementTypes.INTEGER_TYPE
        || fieldElement.schemaType === SchemaElementTypes.FLOAT_TYPE
        || fieldElement.schemaType === SchemaElementTypes.BOOLEAN_TYPE
        || fieldElement.schemaType === SchemaElementTypes.TIMEPOINT_TYPE) {
        repeatable = !!fieldElement.repeatable;
    }
    return repeatable;
};
export var getFallbackReferences = function (element) {
    var fallback;
    if (element.schemaType === SchemaElementTypes.STRING_TYPE
        || element.schemaType === SchemaElementTypes.INTEGER_TYPE
        || element.schemaType === SchemaElementTypes.FLOAT_TYPE
        || element.schemaType === SchemaElementTypes.BOOLEAN_TYPE
        || element.schemaType === SchemaElementTypes.TIMEPOINT_TYPE
        || element.schemaType === SchemaElementTypes.GEOMETRY_TYPE) {
        var fallbackReferences = element.fallbackReferences;
        fallback = fallbackReferences;
    }
    return fallback;
};
export var isLiteralReference = function (elements) {
    return function (reference) { return isLiteral(elements[reference]); };
};
export var getEqualToElements = function (element) {
    var equalToElements = [];
    if (element.schemaType === SchemaElementTypes.STRING_TYPE
        || element.schemaType === SchemaElementTypes.INTEGER_TYPE
        || element.schemaType === SchemaElementTypes.FLOAT_TYPE
        || element.schemaType === SchemaElementTypes.BOOLEAN_TYPE
        || element.schemaType === SchemaElementTypes.TIMEPOINT_TYPE
        || element.schemaType === SchemaElementTypes.GEOMETRY_TYPE) {
        var eqReferences = element.eqReferences, refElements_1 = element.refElements;
        if (eqReferences && refElements_1) {
            equalToElements = eqReferences
                .filter(isLiteralReference(refElements_1))
                .map(function (reference) {
                return refElements_1[reference];
            });
        }
    }
    return equalToElements;
};
export var getSchemaElementDefaultValue = function (element) {
    var defaultValue;
    var isRepeatable = false;
    switch (element.uiType) {
        case UIElementType.CHECKBOX: {
            var _a = element, value = _a.value, repeatable = _a.repeatable;
            defaultValue = !!value;
            isRepeatable = !!repeatable;
            break;
        }
        case UIElementType.COMBO:
        case UIElementType.RADIO:
        case UIElementType.TEXT:
        case UIElementType.TEXTAREA: {
            var _b = element, value = _b.value, repeatable = _b.repeatable;
            defaultValue = value || "";
            isRepeatable = !!repeatable;
            break;
        }
        case UIElementType.MULTISELECT: {
            var _c = element, value = _c.value, repeatable = _c.repeatable;
            defaultValue = Array.isArray(value) ? value : [];
            isRepeatable = !!repeatable;
            break;
        }
        case UIElementType.SLIDER: {
            var _d = element, value = _d.value, repeatable = _d.repeatable;
            defaultValue = value !== null && value !== void 0 ? value : "";
            isRepeatable = !!repeatable;
            break;
        }
        default:
            defaultValue = "";
            break;
    }
    if (isRepeatable && !Array.isArray(defaultValue)) {
        defaultValue = [defaultValue];
    }
    return defaultValue;
};
var getFallbackValue = function (fallbackValueInfo) {
    var fallbackReferences = fallbackValueInfo.fallbackReferences, elements = fallbackValueInfo.elements, elementsValues = fallbackValueInfo.elementsValues, fieldValueInfo = fallbackValueInfo.fieldValueInfo;
    var fieldName = fieldValueInfo.fieldName, fallbackElement = fieldValueInfo.fallbackElement;
    var fallbackValueHolder = null;
    if (fallbackReferences) {
        fallbackReferences.some(function (reference) {
            var element = elements[fieldName] || fallbackElement;
            var fallback = (element === null || element === void 0 ? void 0 : element.refElements) && (element === null || element === void 0 ? void 0 : element.refElements[reference]);
            if (fallback) {
                var defaultValue = fieldValueInfo.defaultValue, repeatable = fieldValueInfo.repeatable, multiSelect = fieldValueInfo.multiSelect, elements_1 = fieldValueInfo.elements;
                fallbackValueHolder = getFieldValue({
                    elementsValues: elementsValues,
                    fieldName: reference,
                    defaultValue: defaultValue,
                    repeatable: repeatable,
                    multiSelect: multiSelect,
                    elements: elements_1,
                    fallbackReferences: fallback.fallbackReferences,
                    fallbackElement: fallback,
                });
            }
            return (fallbackValueHolder && fallbackValueHolder.fieldValue);
        });
    }
    return (fallbackValueHolder && fallbackValueHolder.fieldValue);
};
export var getSimpleFieldValue = function (fieldValueInfo, fallbackValue) {
    var elementsValues = fieldValueInfo.elementsValues, fieldName = fieldValueInfo.fieldName, fallbackElement = fieldValueInfo.fallbackElement, elements = fieldValueInfo.elements, defaultValue = fieldValueInfo.defaultValue;
    var element = elements[fieldName] || fallbackElement;
    var fieldValue;
    if (elementsValues && elementsValues[fieldName] !== undefined && elementsValues[fieldName] !== null) {
        fieldValue = elementsValues[fieldName];
    }
    else if (element && isLiteral(element)) {
        fieldValue = element.literalValue;
    }
    else if (fallbackElement && !fallbackValue) {
        fieldValue = getSchemaElementDefaultValue(fallbackElement);
    }
    else {
        fieldValue = fallbackValue ? fallbackValue : defaultValue;
    }
    return fieldValue;
};
export var getFieldValue = function (fieldValueInfo) {
    var elementsValues = fieldValueInfo.elementsValues, repeatable = fieldValueInfo.repeatable, multiSelect = fieldValueInfo.multiSelect, fallbackReferences = fieldValueInfo.fallbackReferences, elements = fieldValueInfo.elements, defaultValue = fieldValueInfo.defaultValue;
    var fallbackValue = getFallbackValue({
        fieldValueInfo: fieldValueInfo,
        elementsValues: elementsValues,
        elements: elements,
        fallbackReferences: fallbackReferences,
    });
    var fieldValue = getSimpleFieldValue(fieldValueInfo, fallbackValue);
    if (repeatable) {
        if (!Array.isArray(fieldValue)) {
            fieldValue = [fieldValue];
        }
        if (multiSelect) {
            var numberOfValueArrays = fieldValue.filter(Array.isArray).length;
            fieldValue = numberOfValueArrays > 0 && numberOfValueArrays === fieldValue.length
                ? fieldValue
                : [fallbackValue];
        }
    }
    return { fieldValue: fieldValue, defaultValue: fallbackValue ? fallbackValue : defaultValue, fallbackValue: fallbackValue };
};
export var getElementData = function (elementDataInfo) {
    var element = elementDataInfo.element, elements = elementDataInfo.elements, elementsValues = elementDataInfo.elementsValues, segmentPrefix = elementDataInfo.segmentPrefix, translate = elementDataInfo.translate;
    var elementData;
    switch (element.uiType) {
        case UIElementType.CHECKBOX: {
            var _a = element, fieldName = _a.fieldName, optional = _a.optional, repeatable = _a.repeatable, readOnly = _a.readOnly, schemaType = _a.schemaType, fallbackReferences = _a.fallbackReferences, hidden = _a.hidden, calculus = _a.function, injectionType = _a.injectionType, injectionReference = _a.injectionReference;
            var checkboxValueHolder = getFieldValue({
                elementsValues: elementsValues,
                fieldName: segmentPrefix + fieldName,
                defaultValue: getSchemaElementDefaultValue(element),
                repeatable: !!repeatable,
                multiSelect: false,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            elementData = {
                fieldName: fieldName,
                readOnly: !!(readOnly || calculus || (injectionType && injectionReference)),
                required: optional !== undefined && !optional,
                repeatable: !!repeatable,
                schemaType: schemaType,
                valueHolder: checkboxValueHolder,
                hidden: !!hidden,
            };
            break;
        }
        case UIElementType.COMBO: {
            var _b = element, fieldName = _b.fieldName, allowedValues = _b.allowedValues, optional = _b.optional, repeatable = _b.repeatable, readOnly = _b.readOnly, schemaType = _b.schemaType, fallbackReferences = _b.fallbackReferences, hidden = _b.hidden;
            var comboValueHolder = getFieldValue({
                elementsValues: elementsValues,
                fieldName: segmentPrefix + fieldName,
                defaultValue: getSchemaElementDefaultValue(element),
                repeatable: !!repeatable,
                multiSelect: false,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            elementData = {
                fieldName: fieldName,
                readOnly: !!readOnly,
                required: optional !== undefined && !optional,
                repeatable: !!repeatable,
                schemaType: schemaType,
                allowedValues: allowedValues,
                valueHolder: comboValueHolder,
                hidden: !!hidden,
            };
            break;
        }
        case UIElementType.MULTISELECT: {
            var _c = element, schemaType = _c.schemaType, fieldName = _c.fieldName, allowedValues = _c.allowedValues, optional = _c.optional, repeatable = _c.repeatable, readOnly = _c.readOnly, fallbackReferences = _c.fallbackReferences, hidden = _c.hidden;
            var multiSelectValueHolder = getFieldValue({
                elementsValues: elementsValues,
                fieldName: segmentPrefix + fieldName,
                defaultValue: getSchemaElementDefaultValue(element),
                repeatable: !!repeatable,
                multiSelect: true,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            elementData = {
                fieldName: fieldName,
                readOnly: !!readOnly,
                required: optional !== undefined && !optional,
                repeatable: !!repeatable,
                schemaType: schemaType,
                allowedValues: allowedValues,
                valueHolder: multiSelectValueHolder,
                hidden: !!hidden,
            };
            break;
        }
        case UIElementType.RADIO: {
            var _d = element, fieldName = _d.fieldName, schemaType = _d.schemaType, allowedValues = _d.allowedValues, optional = _d.optional, repeatable = _d.repeatable, readOnly = _d.readOnly, fallbackReferences = _d.fallbackReferences, hidden = _d.hidden;
            var radioValueHolder = getFieldValue({
                elementsValues: elementsValues,
                fieldName: segmentPrefix + fieldName,
                defaultValue: getSchemaElementDefaultValue(element),
                repeatable: !!repeatable,
                multiSelect: false,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            elementData = {
                fieldName: fieldName,
                readOnly: !!readOnly,
                required: optional !== undefined && !optional,
                repeatable: !!repeatable,
                schemaType: schemaType,
                allowedValues: allowedValues,
                valueHolder: radioValueHolder,
                hidden: !!hidden,
            };
            break;
        }
        case UIElementType.SLIDER: {
            var _e = element, fieldName = _e.fieldName, schemaType = _e.schemaType, optional = _e.optional, repeatable = _e.repeatable, readOnly = _e.readOnly, fallbackReferences = _e.fallbackReferences, hidden = _e.hidden, lteReferences = _e.lteReferences, gteReferences = _e.gteReferences;
            var sliderValueHolder = getFieldValue({
                elementsValues: elementsValues,
                fieldName: segmentPrefix + fieldName,
                defaultValue: getSchemaElementDefaultValue(element),
                repeatable: !!repeatable,
                multiSelect: false,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            var minValueHolder = getFieldValue({
                elementsValues: elementsValues,
                fieldName: segmentPrefix + gteReferences[0],
                defaultValue: getSchemaElementDefaultValue(element),
                repeatable: !!repeatable,
                multiSelect: false,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            var maxValueHolder = getFieldValue({
                elementsValues: elementsValues,
                fieldName: segmentPrefix + lteReferences[0],
                defaultValue: getSchemaElementDefaultValue(element),
                repeatable: !!repeatable,
                multiSelect: false,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            elementData = {
                fieldName: fieldName,
                readOnly: !!readOnly,
                required: optional !== undefined && !optional,
                repeatable: !!repeatable,
                schemaType: schemaType,
                valueHolder: sliderValueHolder,
                hidden: !!hidden,
                min: minValueHolder.fieldValue,
                max: maxValueHolder.fieldValue,
            };
            break;
        }
        case UIElementType.TEXT:
        case UIElementType.TEXTAREA:
        case UIElementType.INT:
        case UIElementType.FLOAT: {
            var _f = element, fieldName = _f.fieldName, schemaType = _f.schemaType, optional = _f.optional, repeatable = _f.repeatable, readOnly = _f.readOnly, fallbackReferences = _f.fallbackReferences, hidden = _f.hidden, calculus = _f.function, injectionType = _f.injectionType, injectionReference = _f.injectionReference, enumerator = _f.enumerator;
            var textValueHolder = getFieldValue({
                elementsValues: elementsValues,
                fieldName: segmentPrefix + fieldName,
                defaultValue: getSchemaElementDefaultValue(element),
                repeatable: !!repeatable,
                multiSelect: false,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            elementData = {
                fieldName: fieldName,
                readOnly: !!(readOnly || calculus || (injectionType && injectionReference) || enumerator),
                required: optional !== undefined && !optional,
                repeatable: !!repeatable,
                schemaType: schemaType,
                valueHolder: textValueHolder,
                hidden: !!hidden,
            };
            break;
        }
        case UIElementType.LITERAL: {
            var _g = element, fieldName = _g.fieldName, schemaType = _g.schemaType, optional = _g.optional, repeatable = _g.repeatable, readOnly = _g.readOnly, fallbackReferences = _g.fallbackReferences, hidden = _g.hidden;
            var literalValueHolder = getFieldValue({
                elementsValues: null,
                fieldName: segmentPrefix + fieldName,
                defaultValue: "",
                repeatable: !!repeatable,
                multiSelect: false,
                fallbackReferences: fallbackReferences,
                elements: elements,
            });
            elementData = {
                fieldName: fieldName,
                readOnly: !!readOnly,
                required: optional !== undefined && !optional,
                repeatable: !!repeatable,
                schemaType: schemaType,
                valueHolder: literalValueHolder,
                hidden: !!hidden,
            };
            break;
        }
        default:
            var unsupported = translate("utils.SchemaElementsFactory.unsupported.text");
            elementData = {
                fieldName: unsupported,
                readOnly: false,
                required: false,
                repeatable: false,
                schemaType: SchemaElementTypes.STRING_TYPE,
                valueHolder: {
                    fieldValue: unsupported,
                    defaultValue: "",
                    fallbackValue: null
                },
                hidden: false,
            };
            break;
    }
    return elementData;
};
export var getDefaultSchemaReference = function (schemaElements) {
    var _a;
    var reference = "";
    for (var _i = 0, _b = Object.entries(schemaElements); _i < _b.length; _i++) {
        var _c = _b[_i], key = _c[0], value = _c[1];
        var current = value;
        if ((_a = current.editorType) === null || _a === void 0 ? void 0 : _a.defaultView) {
            reference = key;
        }
    }
    return reference;
};
export var getElementsValues = function (elementsValuesInfo) {
    var schemaKey = elementsValuesInfo.schemaKey, elementsValuesMap = elementsValuesInfo.elementsValuesMap, metadataId = elementsValuesInfo.metadataId, elementsValuesType = elementsValuesInfo.elementsValuesType;
    var schemaValues = elementsValuesMap[schemaKey];
    var elementsValues;
    if (schemaValues) {
        if (elementsValuesType === ElementsValuesType.TASK) {
            elementsValues = schemaValues.taskElementsValues && schemaValues.taskElementsValues[metadataId]
                ? __assign({}, schemaValues.taskElementsValues[metadataId]) : {};
        }
        else {
            elementsValues = schemaValues.jobElementsValues && schemaValues.jobElementsValues[metadataId]
                ? __assign({}, schemaValues.jobElementsValues[metadataId]) : {};
        }
    }
    else {
        elementsValues = {};
    }
    return elementsValues;
};
export var getValidationErrors = function (validationErrorsInfo) {
    var schemaKey = validationErrorsInfo.schemaKey, metadataId = validationErrorsInfo.metadataId, validationErrorsMap = validationErrorsInfo.validationErrorsMap, elementsValuesType = validationErrorsInfo.elementsValuesType;
    var schemaErrors = validationErrorsMap[schemaKey];
    var validationErrors;
    if (schemaErrors) {
        if (elementsValuesType === ElementsValuesType.TASK) {
            validationErrors = schemaErrors.taskErrors && schemaErrors.taskErrors[metadataId]
                ? schemaErrors.taskErrors[metadataId].slice()
                : [];
        }
        else {
            validationErrors = schemaErrors.jobErrors && schemaErrors.jobErrors[metadataId]
                ? schemaErrors.jobErrors[metadataId].slice()
                : [];
        }
    }
    else {
        validationErrors = [];
    }
    return validationErrors;
};
export var getComparisonElement = function (comparisonElement, elementsValues, segmentId) {
    var elementName = segmentId ? segmentId + "_" + comparisonElement.fieldName : comparisonElement.fieldName;
    var value = isLiteral(comparisonElement)
        ? comparisonElement.literalValue
        : elementsValues[elementName];
    return { name: comparisonElement.fieldName, value: value };
};
export var getComparisonItems = function (element, elementsValues, segmentId) {
    var comparisonElements;
    if (element.schemaType === SchemaElementTypes.STRING_TYPE
        || element.schemaType === SchemaElementTypes.INTEGER_TYPE
        || element.schemaType === SchemaElementTypes.FLOAT_TYPE
        || element.schemaType === SchemaElementTypes.BOOLEAN_TYPE
        || element.schemaType === SchemaElementTypes.TIMEPOINT_TYPE
        || element.schemaType === SchemaElementTypes.GEOMETRY_TYPE) {
        var eqReferences = element.eqReferences, gtReferences = element.gtReferences, gteReferences = element.gteReferences, ltReferences = element.ltReferences, lteReferences = element.lteReferences, refElements_2 = element.refElements;
        if (refElements_2) {
            if (eqReferences) {
                comparisonElements = comparisonElements || {};
                comparisonElements[ComparisonReferences.EQ] = eqReferences.map(function (reference) {
                    return getComparisonElement(refElements_2[reference], elementsValues, segmentId);
                });
            }
            if (gtReferences) {
                comparisonElements = comparisonElements || {};
                comparisonElements[ComparisonReferences.GT] = gtReferences.map(function (reference) {
                    return getComparisonElement(refElements_2[reference], elementsValues, segmentId);
                });
            }
            if (gteReferences) {
                comparisonElements = comparisonElements || {};
                comparisonElements[ComparisonReferences.GTE] = gteReferences.map(function (reference) {
                    return getComparisonElement(refElements_2[reference], elementsValues, segmentId);
                });
            }
            if (ltReferences) {
                comparisonElements = comparisonElements || {};
                comparisonElements[ComparisonReferences.LT] = ltReferences.map(function (reference) {
                    return getComparisonElement(refElements_2[reference], elementsValues, segmentId);
                });
            }
            if (lteReferences) {
                comparisonElements = comparisonElements || {};
                comparisonElements[ComparisonReferences.LTE] = lteReferences.map(function (reference) {
                    return getComparisonElement(refElements_2[reference], elementsValues, segmentId);
                });
            }
        }
    }
    return comparisonElements;
};
